module.exports = __webpack_public_path__ + "media/images/li-97353c5ebc8c094c4553e819b2bc4f56.svg";